import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatTableDataSource, MatDialog, MatDialogRef } from '@angular/material';
import { DraftService } from 'src/app/resultboard/draft/draft.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { PlayerinfoboxComponent } from 'src/app/playerinfobox/playerinfobox.component';
import { Router } from '@angular/router';
import { PlayersListData } from '../store/actions/appActions';

@Component({
  selector: 'app-rosterspopup',
  templateUrl: './rosterspopup.component.html',
  styleUrls: ['./rosterspopup.component.scss']
})

export class RosterspopupComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['position', 'player', 'drafted'];
  public dataSource;
  parameters: any;
  sub_Teams: Subscription;
  teamList: any;
  team_image: string;
  assetURL: string;
  noOfRecord = 0;
  isMobile = false;
  leagueRecord:any;
  league_member_id: string;
  is_tournament: string;
  playerList:any;
  loginUserID: number;
  playerInfoDialogRef: MatDialogRef<PlayerinfoboxComponent>;

  constructor(private _draftService: DraftService,
    @Inject(MAT_DIALOG_DATA) private data,
    private store: Store<AppState>,
    public dialog: MatDialog,
    private router: Router,
    private deviceService: DeviceDetectorService) {
    this.isMobile = this.deviceService.isMobile();
    this.parameters = data;
  }

  ngOnInit() {
    this.assetURL = `${environment.assetURL}`;
    this.is_tournament = this.router.url.split('/')['6'];
    
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser !== null) {
      this.loginUserID = currentUser.id;
    }
    this.getTeamsData();
    this.leagueRecordData();
  }

  getTeamsData() {
    if (this.parameters.team_id) {
      this.sub_Teams = this._draftService.getTeamListForSlider(this.parameters.team_id).subscribe(res => {
        if (res.status === 'success') {
          const teamList = res.entities;
          const newArr = []; 
          teamList.forEach((element, key) => {
            const newRow = {
              position: element.abbr, player: element.first_name + ' ' +
                element.last_name + '-' + element.team.toUpperCase(), player1: element.team, drafted: 'Round ' +
                  (key + 1) + ' (' + element.pick_number + ')',player_id:element.id
            };
            newArr.push(newRow);
          });
          this.playerList = newArr;
          this.dataSource = new MatTableDataSource(newArr);
          this.noOfRecord = newArr.length;
        }
      });
    }
  }
  
  leagueRecordData(){ 
    this.store.select('league_draft').subscribe(state => {
      if (state.length > 0) {
        this.leagueRecord = state[0]; 
        let league_member_id = '';
        if (this.is_tournament === `${environment.tournament}`) {
          if (this.leagueRecord.league_players) {
            this.leagueRecord.league_players.forEach(element => {
              if (Number(element.user_id) === Number(this.loginUserID)) {
                league_member_id = element.id;
              }
            });
          } else {
            league_member_id = this.leagueRecord.league_currenct_id;
          }
        } else {
          league_member_id = this.leagueRecord.league_member_id;
        }
        this.league_member_id = league_member_id; 
      }
    });
  }

  openPlayerInfoBox(player_id) {
    if (player_id && this.league_member_id) {
      if(Number(this.parameters.timer_condition_no) === 3){
        this.store.dispatch(new PlayersListData(
          this.playerList
        ));
      }
      
      const abbr = (typeof (this.leagueRecord.abbr) !== 'undefined') ? this.leagueRecord.abbr : 'false';
      this.playerInfoDialogRef = this.dialog.open(PlayerinfoboxComponent, {
        width: '1150px',
        data: {
          'player_id': player_id, 'season_id': this.leagueRecord.active_season_id, 'league_id': this.leagueRecord.id, 'league_team_id': this.league_member_id,
          'abbr': abbr, 'draft_status': this.leagueRecord.league_status, 'leagueRecord': this.leagueRecord.is_paused, 'prePlayer': 0, 'nextPlayer': 0, 'draftSelectBox': []
        }
      });
    }
  }
  
  ngOnDestroy() {
    if (this.sub_Teams) {
      this.sub_Teams.unsubscribe();
    }
  }
}
